import { useContext } from 'react';
import {
  ScenarioActionsContext,
  type ScenarioActionsContextValue,
} from '../providers/scenarioActionsContext';

/**
 * The interaction layer, or null where none is mounted.
 *
 * **Null rather than a throw**, deliberately: a card rendered in a preview, a story, or a
 * read-only surface should come out inert, not crash. Every consumer treats a null value
 * as "no actions available" and the card's own gating hides the affordances.
 */
export const useScenarioActions = (): ScenarioActionsContextValue | null =>
  useContext(ScenarioActionsContext);
